import { SABRE_BEDBANK_SUPPLIER_CODE } from 'constants/bedbank'
import { ELIGIBLE_FOR_HOTEL_LOYALTY_POINTS_INCLUSION_DESCRIPTION } from 'lib/search/constants'

export type HotelLoyaltyBedbankRate = {
  supplierCode?: string
  bedbankSupplierCode?: string
  inclusions?: Array<{ description: string }>
}

export type HotelLoyaltyFeatureFlags = {
  isHotelLoyaltyEnabled: boolean
  sabreHotelsEnabled: boolean
}

export function getBedbankSupplierCode(rate: Pick<HotelLoyaltyBedbankRate, 'supplierCode' | 'bedbankSupplierCode'>): string | undefined {
  return rate.supplierCode ?? rate.bedbankSupplierCode
}

export function isSabreBedbankSupplier(supplierCode?: string): boolean {
  return supplierCode === SABRE_BEDBANK_SUPPLIER_CODE
}

export function hasHotelLoyaltyPointsInclusion(
  inclusions?: Array<{ description: string }>,
): boolean {
  return inclusions?.some(
    inclusion => inclusion.description === ELIGIBLE_FOR_HOTEL_LOYALTY_POINTS_INCLUSION_DESCRIPTION,
  ) ?? false
}

export function isBedbankRateEligibleForHotelLoyaltyProgram(
  rate: HotelLoyaltyBedbankRate,
  flags: HotelLoyaltyFeatureFlags,
): boolean {
  if (!flags.isHotelLoyaltyEnabled || !flags.sabreHotelsEnabled) {
    return false
  }

  const supplierCode = getBedbankSupplierCode(rate)

  return isSabreBedbankSupplier(supplierCode) && hasHotelLoyaltyPointsInclusion(rate.inclusions)
}

export function isSearchTileEligibleForHotelLoyaltyProgram(
  options: {
    rates?: Array<HotelLoyaltyBedbankRate>
    searchPricing?: { isEligibleForLoyaltyProgram?: boolean }
  },
  flags: HotelLoyaltyFeatureFlags,
): boolean {
  if (!flags.isHotelLoyaltyEnabled || !flags.sabreHotelsEnabled) {
    return false
  }

  if (options.rates?.some(rate => isBedbankRateEligibleForHotelLoyaltyProgram(rate, flags))) {
    return true
  }

  return options.searchPricing?.isEligibleForLoyaltyProgram ?? false
}
